import axios from '../axiosApi';
import {
    FETCH_ITEM_CODIGO_BARRAS,
    FETCH_TIRE_BANDS,
    FETCH_TIRE_BRANDS,
    FETCH_TIRE_MODELS,
    FETCH_TIRE_SIZES, NEW_BANDA, NEW_BANDA_SUCCESS,
    NEW_TIRE_BRAND,
    NEW_TIRE_BRAND_SUCCESS,
    NEW_TIRE_MODEL,
    NEW_TIRE_MODEL_SUCCESS,
    NEW_TIRE_SIZE,
    NEW_TIRE_SIZE_SUCCESS, RECEIVE_ITEM_CODIGO_BARRAS,
    RECEIVE_TIRE_BANDS,
    RECEIVE_TIRE_BRANDS,
    RECEIVE_TIRE_MODELS,
    RECEIVE_TIRE_SIZES
} from "./actionTypes";

export const fetchTireBrands =  () => ({
    type: FETCH_TIRE_BRANDS
});

export const receiveTireBrands = payload => ({
    type: RECEIVE_TIRE_BRANDS,
    payload: payload
});

export const dpnewTireBrand =  () => ({
    type: NEW_TIRE_BRAND
});

export const dpnewTireBrandSuccess = payload => ({
    type: NEW_TIRE_BRAND_SUCCESS,
    payload: payload
});


export const fetchTireModels =  () => ({
    type: FETCH_TIRE_MODELS
});

export const receiveTireModels = payload => ({
    type: RECEIVE_TIRE_MODELS,
    payload: payload
});

export const dpnewTireModel =  () => ({
    type: NEW_TIRE_MODEL
});

export const dpnewTireModelSuccess = payload => ({
    type: NEW_TIRE_MODEL_SUCCESS,
    payload: payload
});

export const fetchTireSizes =  () => ({
    type: FETCH_TIRE_SIZES
});

export const receiveTireSizes = payload => ({
    type: RECEIVE_TIRE_SIZES,
    payload: payload
});

export const dpnewTireSize =  () => ({
    type: NEW_TIRE_SIZE
});

export const dpnewTireSizeSuccess = payload => ({
    type: NEW_TIRE_SIZE_SUCCESS,
    payload: payload
});


export const fetchTireBands =  () => ({
    type: FETCH_TIRE_BANDS
});

export const receiveTireBands = payload => ({
    type: RECEIVE_TIRE_BANDS,
    payload: payload
});

export const dpnewBanda =  () => ({
    type: NEW_BANDA
});

export const dpnewBandaSuccess = payload => ({
    type: NEW_BANDA_SUCCESS,
    payload: payload
});

export const fetchItemCodigoBarras =  () => ({
    type: FETCH_ITEM_CODIGO_BARRAS
});

export const receiveItemCodigoBarras = payload => ({
    type: RECEIVE_ITEM_CODIGO_BARRAS,
    payload: payload
});

export const getDadosPneus = () => {
    console.log("getDadosPneus");
    return async dispatch => {
        dispatch(getTireBrands());
        dispatch(getTireModels());
        dispatch(getTireSizes());
        dispatch(getTireBands());
    }
}

export const getTireBrands = () => {
    return async dispatch => {
        dispatch(fetchTireBrands());
        let payload;
        try {
            const response = await axios.get(`/pneu-fabricantes`)
            payload = {
                error: false,
                result: "OK",
                message: "",
                data: response.data
            };
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                message: e,
                data: []
            };
        }
        finally {
            dispatch(receiveTireBrands(payload));
        }
    }
};

export const newTireBrand = (tireBrand) => {
    return async dispatch => {
        dispatch(dpnewTireBrand());
        let payload;
        try {
            console.log("newTireBrand", tireBrand)
            const response = await axios.post(`/pneu-fabricantes`, tireBrand)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewTireBrandSuccess(payload));
            dispatch(getTireBrands());
        }
    }
}

export const getTireModels = () => {
    return async dispatch => {
        console.log("getTireModels")

        dispatch(fetchTireModels());
        let payload;
        try {
            const response = await axios.get(`/pneu-modelos`)
            payload = {
                error: false,
                result: "OK",
                message: "",
                data: response.data
            };
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                message: e,
                data: []
            };
        }
        finally {
            dispatch(receiveTireModels(payload));

        }


    }
};

export const newTireModel = (tireModel) => {
    return async dispatch => {
        dispatch(dpnewTireModel());
        let payload;
        try {
            const response = await axios.post(`/pneu-modelos`, tireModel)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewTireModelSuccess(payload));
            dispatch(getTireModels());
        }
    }
}

export const getTireSizes = () => {
    return async dispatch => {
        dispatch(fetchTireSizes());
        let payload;
        try {
            const response = await axios.get(`/pneu-medidas`)
            payload = {
                error: false,
                result: "OK",
                message: "",
                data: response.data
            };
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                message: e,
                data: []
            };
        }
        finally {
            dispatch(receiveTireSizes(payload));
        }
    }
};

export const newTireSize = (tireSize) => {
    return async dispatch => {
        dispatch(dpnewTireSize());
        let payload;
        try {
            const response = await axios.post(`/pneu-medidas`, tireSize)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewTireSizeSuccess(payload));
        }
    }
}

export const getTireBands = () => {
    return async dispatch => {
        dispatch(fetchTireBands());
        let payload;
        try {
            const response = await axios.get(`/bandas`)
            payload = {
                error: false,
                result: "OK",
                message: "",
                data: response.data
            };
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                message: e,
                data: []
            };
        }
        finally {
            dispatch(receiveTireBands(payload));
        }
    }
};

export const newBanda = (banda) => {
    return async dispatch => {
        dispatch(dpnewBanda());
        let payload;
        try {
            const response = await axios.post(`/bandas`, banda)
            payload = response.data
        }
        catch(e) {
            payload = { error: true };
        }
        finally {

            dispatch(dpnewBandaSuccess(payload));
        }
    }
}

export const getItemCodigoBarras = () => {
    return async dispatch => {
        dispatch(fetchItemCodigoBarras());
        let payload;
        try {
            const response = await axios.get(`/items?filter={ "include":[ { "relation": "banda" } ]  } `);
            payload = {
                error: false,
                result: "OK",
                message: "",
                data: response.data
            };
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                message: e,
                data: []
            };
        }
        finally {
            dispatch(receiveItemCodigoBarras(payload));
        }
    }
};

